import { subject } from "@casl/ability";
import { useQuery } from "@tanstack/react-query";
import { FirestoreError } from "firebase/firestore";
import useUserStore from "@/modules/users/store";
import { getComitesInovacao, QUERY_KEY as COMITE_INOVACAO_COLLECTION } from "../../firestore";

type TGetComitesInovacaoResponse = Awaited<ReturnType<typeof getComitesInovacao>>;

/**
 * Get comites de inovação query hook
 * @returns Comites de inovação query hook
 */
function useQueryComitesInovacao() {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresaId);

  return useQuery<TGetComitesInovacaoResponse, FirestoreError, TComiteInovacao[]>({
    queryKey: ["empresas", { id: activeEmpresaId }, COMITE_INOVACAO_COLLECTION],
    queryFn() {
      if (!activeEmpresaId) {
        throw new Error("Empresa não selecionada");
      }

      return getComitesInovacao(activeEmpresaId);
    },
    select(dataResponse) {
      if (dataResponse.empty) {
        return [];
      }
      return dataResponse.docs.map((document_) => subject("TComiteInovacao", document_.data()));
    }
  });
}

export default useQueryComitesInovacao;
